const VOTED_STORAGE_PREFIX = "cb-article-rated-";

/**
 * «Содержание статьи» — сворачивание списка.
 */
function initToc() {
	const toc = document.querySelector("[data-article-toc]");

	if (!toc) {
		return;
	}

	const toggle = toc.querySelector("[data-article-toc-toggle]");
	const list = toc.querySelector(".article-toc__list");

	if (!toggle || !list) {
		return;
	}

	toggle.addEventListener("click", () => {
		const isOpen = toggle.getAttribute("aria-expanded") === "true";

		toggle.setAttribute("aria-expanded", isOpen ? "false" : "true");
		toggle.textContent = isOpen ? toggle.dataset.labelShow : toggle.dataset.labelHide;

		if (isOpen) {
			list.setAttribute("hidden", "");
		} else {
			list.removeAttribute("hidden");
		}
	});
}

/**
 * Подсветка звёзд до наведённой/выбранной.
 */
function paintStars(stars, value) {
	stars.forEach((star) => {
		star.classList.toggle("is-active", Number(star.value) <= value);
	});
}

/**
 * «Оцените статью» — отправка голоса и обновление среднего значения.
 */
function initRating() {
	const widget = document.querySelector("[data-article-rate]");
	const settings = window.creditbarArticle;

	if (!widget || !settings || !settings.ajaxUrl || !settings.nonce) {
		return;
	}

	const group = widget.querySelector("[data-article-rate-stars]");
	const message = widget.querySelector("[data-article-rate-message]");
	const label = document.querySelector("[data-article-rate-label]");

	if (!group) {
		return;
	}

	const postId = widget.dataset.postId;
	const stars = Array.from(group.querySelectorAll(".article-rate__star"));
	const initialValue = Number(group.dataset.value) || 0;
	const storageKey = VOTED_STORAGE_PREFIX + postId;

	let voted = false;

	try {
		voted = window.localStorage.getItem(storageKey) === "1";
	} catch (error) {
		voted = false;
	}

	if (voted) {
		widget.classList.add("is-voted");
	}

	group.addEventListener("mouseover", (event) => {
		const star = event.target.closest(".article-rate__star");

		if (!star || voted) {
			return;
		}

		paintStars(stars, Number(star.value));
	});

	group.addEventListener("mouseleave", () => {
		if (voted) {
			return;
		}

		paintStars(stars, Number(group.dataset.value) || initialValue);
	});

	group.addEventListener("click", (event) => {
		const star = event.target.closest(".article-rate__star");

		if (!star || voted) {
			return;
		}

		const value = Number(star.value);

		voted = true;
		widget.classList.add("is-voted");
		paintStars(stars, value);

		try {
			window.localStorage.setItem(storageKey, "1");
		} catch (error) {
			// приватный режим — просто не запоминаем голос
		}

		const formData = new FormData();
		formData.append("action", "creditbar_article_rate");
		formData.append("nonce", settings.nonce);
		formData.append("post_id", postId);
		formData.append("value", String(value));

		fetch(settings.ajaxUrl, {
			method: "POST",
			credentials: "same-origin",
			body: formData,
		})
			.then((response) => response.json())
			.then((response) => {
				if (!response || !response.success || !response.data) {
					return;
				}

				group.dataset.value = String(Math.round(response.data.value));

				if (label) {
					label.textContent = response.data.label;
				}

				if (message) {
					message.removeAttribute("hidden");
				}
			})
			.catch(() => {
				if (message) {
					message.removeAttribute("hidden");
				}
			});
	});
}

/**
 * Кнопка «Поделиться»: системный шеринг, иначе копирование ссылки.
 */
function initShare() {
	const button = document.querySelector("[data-article-share]");

	if (!button) {
		return;
	}

	const label = button.querySelector(".article-share__label");

	button.addEventListener("click", async () => {
		const shareData = {
			title: document.title,
			url: window.location.href,
		};

		if (navigator.share) {
			try {
				await navigator.share(shareData);

				return;
			} catch (error) {
				return;
			}
		}

		try {
			await navigator.clipboard.writeText(shareData.url);

			if (label) {
				const original = label.textContent;

				label.textContent = button.dataset.copied || original;
				window.setTimeout(() => {
					label.textContent = original;
				}, 2000);
			}
		} catch (error) {
			window.prompt("", shareData.url);
		}
	});
}

document.addEventListener("DOMContentLoaded", () => {
	initToc();
	initRating();
	initShare();
});
